const QrCode = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(-0.243)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4292)">
        <g transform="translate(-635.757 4292)">
          <g transform="translate(0.15 0.15)">
            <path
              d="M372.433,4.987a.554.554,0,0,1-.554-.554V1.593a.485.485,0,0,0-.485-.485h-2.84a.554.554,0,1,1,0-1.108h2.84a1.6,1.6,0,0,1,1.593,1.593v2.84A.554.554,0,0,1,372.433,4.987Z"
              transform="translate(-355.256 0)"
            />
            <path
              d="M.554,4.987A.554.554,0,0,1,0,4.433V1.593A1.6,1.6,0,0,1,1.593,0h2.84a.554.554,0,0,1,0,1.108H1.593a.485.485,0,0,0-.485.485v2.84A.554.554,0,0,1,.554,4.987Z"
              transform="translate(0 0)"
            />
            <path
              d="M4.433,372.987H1.593A1.6,1.6,0,0,1,0,371.394v-2.84a.554.554,0,1,1,1.108,0v2.84a.485.485,0,0,0,.485.485h2.84a.554.554,0,0,1,0,1.108Z"
              transform="translate(0 -355.256)"
            />
            <path
              d="M371.394,372.987h-2.84a.554.554,0,0,1,0-1.108h2.84a.485.485,0,0,0,.485-.485v-2.84a.554.554,0,0,1,1.108,0v2.84A1.6,1.6,0,0,1,371.394,372.987Z"
              transform="translate(-355.256 -355.256)"
            />
            <path
              d="M68.5,70.095H65.593A1.6,1.6,0,0,1,64,68.5V65.593A1.6,1.6,0,0,1,65.593,64H68.5a1.6,1.6,0,0,1,1.593,1.593V68.5A1.6,1.6,0,0,1,68.5,70.095Zm-2.909-4.987a.485.485,0,0,0-.485.485V68.5a.485.485,0,0,0,.485.485H68.5a.485.485,0,0,0,.485-.485V65.593a.485.485,0,0,0-.485-.485Z"
              transform="translate(-61.784 -61.784)"
            />
            <path
              d="M68.5,278.095H65.593A1.6,1.6,0,0,1,64,276.5v-2.909A1.6,1.6,0,0,1,65.593,272H68.5a1.6,1.6,0,0,1,1.593,1.593V276.5A1.6,1.6,0,0,1,68.5,278.095Zm-2.909-4.987a.485.485,0,0,0-.485.485V276.5a.485.485,0,0,0,.485.485H68.5a.485.485,0,0,0,.485-.485v-2.909a.485.485,0,0,0-.485-.485Z"
              transform="translate(-61.784 -262.581)"
            />
            <path
              d="M276.5,70.095h-2.909A1.6,1.6,0,0,1,272,68.5V65.593A1.6,1.6,0,0,1,273.593,64H276.5a1.6,1.6,0,0,1,1.593,1.593V68.5A1.6,1.6,0,0,1,276.5,70.095Zm-2.909-4.987a.485.485,0,0,0-.485.485V68.5a.485.485,0,0,0,.485.485H276.5a.485.485,0,0,0,.485-.485V65.593a.485.485,0,0,0-.485-.485Z"
              transform="translate(-262.581 -61.784)"
            />
            <path
              d="M277.194,274.77h-1.316V272.9a.9.9,0,0,0-.9-.9H272.9a.9.9,0,0,0-.9.9v2.078a.9.9,0,0,0,.9.9h1.87v1.316a.9.9,0,0,0,.9.9h1.524a.9.9,0,0,0,.9-.9v-1.524A.9.9,0,0,0,277.194,274.77Zm-4.086-1.662h1.662v1.662h-1.662Zm3.879,3.879h-1.108v-1.108h1.108Z"
              transform="translate(-262.581 -262.581)"
            />
            <path
              d="M129.108,129.662h-.554a.554.554,0,0,1-.554-.554v-.554a.554.554,0,0,1,.554-.554h.554a.554.554,0,0,1,.554.554v.554A.554.554,0,0,1,129.108,129.662Z"
              transform="translate(-123.567 -123.567)"
            />
            <path
              d="M337.108,129.662h-.554a.554.554,0,0,1-.554-.554v-.554a.554.554,0,0,1,.554-.554h.554a.554.554,0,0,1,.554.554v.554A.554.554,0,0,1,337.108,129.662Z"
              transform="translate(-324.364 -123.567)"
            />
            <path
              d="M129.108,337.662h-.554a.554.554,0,0,1-.554-.554v-.554a.554.554,0,0,1,.554-.554h.554a.554.554,0,0,1,.554.554v.554A.554.554,0,0,1,129.108,337.662Z"
              transform="translate(-123.567 -324.364)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default QrCode;
